<template>
  <section>
    <!--工具条-->
    <CompanyToolbar :buttonList="buttonList" @callFunction="callFunction"></CompanyToolbar>

    <!--列表-->
    <el-table
      :data="companys"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="80"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="80">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="CompanyName" fixed="left" label="企业名称" width="260" sortable></el-table-column>
      <el-table-column prop="ParentCompanyName" label="上级机构" width="180" sortable></el-table-column>
      <el-table-column prop="OperatingStatus" label="经营状态" width="100" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.OperatingStatus  ? 'success' : 'danger'"
            disable-transitions
          >{{scope.row.OperatingStatus ? "营运":"停运"}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CBLAccount" label="车百路账号" width="120" sortable></el-table-column>
      <el-table-column prop="CBLPassword" label="车百路密码" width="120" sortable></el-table-column>
      <el-table-column prop="LegalRepresentative" label="法定代表人" width="120" sortable></el-table-column>
      <el-table-column prop="ContactNumber" label="联系电话" width="120" sortable></el-table-column>
      <el-table-column prop="BusinessLicenseNo" label="营业执照号" width="120" sortable></el-table-column>
      <el-table-column prop="OwnershipNature" label="所有权性质" width="120" sortable></el-table-column>
      <el-table-column prop="RegisteredCapital" label="注册资金" width="120" sortable></el-table-column>
      <el-table-column prop="EmployeesNumber" label="职工人数" width="100" :formatter="employeesNumberFormat" sortable></el-table-column>
      <el-table-column prop="VehiclesNumber" label="车辆总数" width="100" :formatter="vehiclesNumberFormat" sortable></el-table-column>
      <el-table-column prop="LineNumber" label="线路总数" width="100" :formatter="lineNumberFormat" sortable></el-table-column>
      <el-table-column prop="BusinessScope" label="经营范围" width="200" sortable></el-table-column>
      <el-table-column prop="Address" label="企业地址" width="200" sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="100" sortable></el-table-column>
      <el-table-column prop="Enabled" label="状态" width="200" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled  ? 'success' : 'danger'"
            disable-transitions
          >{{scope.row.Enabled ? "正常":"禁用"}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
      <el-row>
          <el-form-item label="企业名称" prop="CompanyName" label-width="100px">
            <el-input v-model="editForm.CompanyName" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="上级机构" prop="ParentId" label-width="100px">
            <el-select style="width: 100%;" v-model="editForm.ParentId" placeholder="请选择上级机构">
              <el-option
                v-for="item in companys"
                :key="item.Id"
                :value="item.Id"
                :label="item.CompanyName"
              >
                <span style="float: left">{{ item.CompanyName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="状态" prop="Enabled" label-width="100px">
              <el-select v-model="editForm.Enabled" placeholder="请选择企业状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="经营状态" prop="OperatingStatus" label-width="100px">
              <el-select v-model="editForm.OperatingStatus" placeholder="请选择经营状态">
                <el-option
                  v-for="item in operatingStatusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车百路账号" prop="CBLAccount" label-width="100px">
              <el-input v-model="editForm.CBLAccount" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车百路密码" prop="CBLPassword" label-width="100px">
              <el-input v-model="editForm.CBLPassword" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="法定代表人" prop="LegalRepresentative" label-width="100px">
              <el-input v-model="editForm.LegalRepresentative" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="联系电话" prop="ContactNumber" label-width="100px">
              <el-input v-model="editForm.ContactNumber" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="营业执照号" prop="BusinessLicenseNo" label-width="100px">
              <el-input v-model="editForm.BusinessLicenseNo" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="所有权性质" prop="OwnershipNature" label-width="100px">
              <el-input v-model="editForm.OwnershipNature" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="注册资金" prop="RegisteredCapital" label-width="100px">
              <el-input v-model="editForm.RegisteredCapital" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="职工人数" prop="EmployeesNumber" label-width="100px">
              <el-input v-number-only v-model="editForm.EmployeesNumber" style="width:170px" /> 名
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车辆总数" prop="VehiclesNumber" label-width="100px">
              <el-input v-number-only v-model="editForm.VehiclesNumber" style="width:170px" /> 辆
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路总数" prop="LineNumber" label-width="100px">
              <el-input v-number-only v-model="editForm.LineNumber" style="width:170px" /> 条
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="经营范围" prop="BusinessScope" label-width="100px">
            <el-input rows="3" type="textarea" v-model="editForm.BusinessScope" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="企业地址" prop="Address" label-width="100px">
            <el-input v-model="editForm.Address" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-form-item label="企业名称" prop="CompanyName" label-width="100px">
            <el-input v-model="addForm.CompanyName" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="上级机构" prop="ParentId" label-width="100px">
            <el-select style="width: 100%;" v-model="addForm.ParentId" placeholder="请选择上级机构">
              <el-option
                v-for="item in companys"
                :key="item.Id"
                :value="item.Id"
                :label="item.CompanyName"
              >
                <span style="float: left">{{ item.CompanyName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="状态" prop="Enabled" label-width="100px">
              <el-select v-model="addForm.Enabled" placeholder="请选择企业状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="经营状态" prop="OperatingStatus" label-width="100px">
              <el-select v-model="addForm.OperatingStatus">
                <el-option label="营运" value="true"></el-option>
                <el-option label="停运" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车百路账号" prop="CBLAccount" label-width="100px">
              <el-input v-model="addForm.CBLAccount" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车百路密码" prop="CBLPassword" label-width="100px">
              <el-input v-model="addForm.CBLPassword" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="法定代表人" prop="LegalRepresentative" label-width="100px">
              <el-input v-model="addForm.LegalRepresentative" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="联系电话" prop="ContactNumber" label-width="100px">
              <el-input v-model="addForm.ContactNumber" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="营业执照号" prop="BusinessLicenseNo" label-width="100px">
              <el-input v-model="addForm.BusinessLicenseNo" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="所有权性质" prop="OwnershipNature" label-width="100px">
              <el-input v-model="addForm.OwnershipNature" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="注册资金" prop="RegisteredCapital" label-width="100px">
              <el-input v-model="addForm.RegisteredCapital" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="职工人数" prop="EmployeesNumber" label-width="100px">
              <el-input v-number-only v-model="addForm.EmployeesNumber" style="width:170px" /> 名
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车辆总数" prop="VehiclesNumber" label-width="100px">
              <el-input v-number-only v-model="addForm.VehiclesNumber" style="width:170px" /> 辆
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路总数" prop="LineNumber" label-width="100px">
              <el-input v-number-only v-model="addForm.LineNumber" style="width:170px" /> 条
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="经营范围" prop="BusinessScope" label-width="100px">
            <el-input rows="3" type="textarea" v-model="addForm.BusinessScope" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="企业地址" prop="Address" label-width="100px">
            <el-input v-model="addForm.Address" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="operateDataLogFormVisible"
      v-model="operateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getCompanyListPage, removeCompany, editCompany, addCompany, initVehiclesData } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import CompanyToolbar from "../../components/QueryToolbar/CompanyToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { CompanyToolbar,OperateDataLog },
  data() {
    return {
      filters: {
        companyName: "",
        operatingStatus: "true",
        enabled: "true"
      },
      entityName: 'Company', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      companys: [], //企业列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      operatingStatusList: [
        { name: "营运", value: true },
        { name: "停运", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      editLoading: false,
      editFormRules: {
        CompanyName: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        CBLAccount: [{ required: true, message: "请输入车百路账号", trigger: "blur" }],
        CBLPassword: [{ required: true, message: "请输入车百路密码", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        CompanyName: "",
        ParentId: 0,
        Enabled: false,
        OperatingStatus: false,
        CBLAccount: "",
        CBLPassword: "",
        LegalRepresentative: "",
        ContactNumber: "",
        BusinessLicenseNo: "",
        OwnershipNature: "",
        BusinessScope: "",
        RegisteredCapital: "",
        Address: "",
        EmployeesNumber: 0,
        VehiclesNumber: 0,
        LineNumber: 0
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CompanyName: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        CBLAccount: [{ required: true, message: "请输入车百路账号", trigger: "blur" }],
        CBLPassword: [{ required: true, message: "请输入车百路密码", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        CompanyName: "",
        ParentId: 0,
        Enabled: "true",
        OperatingStatus: "true",
        CBLAccount: "",
        CBLPassword: "",
        LegalRepresentative: "",
        ContactNumber: "",
        BusinessLicenseNo: "",
        OwnershipNature: "",
        BusinessScope: "",
        RegisteredCapital: "",
        Address: "",
        EmployeesNumber: 0,
        VehiclesNumber: 0,
        LineNumber: 0
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        companyName: item.companyName,
        operatingStatus: item.operatingStatus,
        enabled: item.enabled
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    //性别显示转换
    formatEnabled: function(row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    employeesNumberFormat(row, column) {
      return row.EmployeesNumber + ' 名'; 
    },
    vehiclesNumberFormat(row, column) {
      return row.VehiclesNumber + ' 辆'; 
    },
    lineNumberFormat(row, column) {
      return row.LineNumber + ' 条'; 
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getCompany();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCompany();
    },
    queryCompany(){
      this.page = 1;
      this.getCompany();
    },
    //获取企业列表
    getCompany() {
      let _this = this;
      let para = {
        companyName: _this.filters.companyName,
        operatingStatus: _this.filters.operatingStatus,
        enabled: _this.filters.enabled,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getCompanyListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.companys = res.data.response.data;
        _this.listLoading = false;
      });
    },
    // 初始化用户关联车辆数据
    handleInit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要初始化车辆数据的一行！",
          type: "error"
        });

        return;
      }
       this.$confirm("确认初始化车辆数据吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          let para = { companyId: row.Id };
          initVehiclesData(para).then(res => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: "初始化车辆数据成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          });
        })
        .catch(() => {});
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeCompany(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getCompany();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CompanyName: "",
        Enabled: "true",
        OperatingStatus: "true"
      };
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            editCompany(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getCompany();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addCompany(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getCompany();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getCompany();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
